import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { getMaterials } from '../../services/materials';
import { onQuerySuccess } from '../../utils/queryResponse';
import FormSelect from '../forms/formSelect';

const MaterialSelect = ({ value, materialId, ...rest }) => {

    const [options, setOptions] = useState([])

    const { data, isLoading } = useQuery(['materials', 'select'], () => getMaterials({ excludeDisabled: true }))

    useEffect(() => {
        onQuerySuccess(data, (result) => {
            const list = result.data || result
            if (list.length > 0) {
                let _options = [...list]
                if (materialId) {
                    const existing = list.find(x => x.id === materialId)
                    if (!existing) _options = list
                }
                setOptions(_options.map(d => ({
                    value: d.id, label: d.name, ppu: d.sellingPrice, unit: d.unit, taxRate: d.taxRate
                })))
            }
        })
    }, [data, materialId])

    return (
        <FormSelect {...rest}
            value={options.find(opt => opt.value === value) || null}
            options={options}
            isLoading={isLoading}
        />
    )
}

export default MaterialSelect
